<template lang="html">
  <!-- This is a component to be a parent for other routes -->
  <router-view />
</template>

<script>
export default {};
</script>

<style lang="css" scoped></style>
